
import { LANGUAGE_CHANGE, SELECTED_LANG, SMARTLOGIN } from './Constants';
import { RC4Decrypt, RC4Encrypt } from './RC4EncDec';
import { useEffect, useRef } from 'react';


import { getOddPlaces } from '../http/ApiHeaders';

import { sha512 } from 'js-sha512';
import { useSearchParams } from 'react-router-dom';


export const GetQueryString = () => {
  let output = "";
  const [searchParams] = useSearchParams();
  const queryLang = searchParams.get('lang');
  alert("lang:"+queryLang);
  const encyptdVal = searchParams.get('enc');
   output = RC4Decrypt(encyptdVal)
  // console.log("output:"+output+"");
  return output;
};

export const GetCacheKey = (urlkey) => {
  try {
    let _uky = window.sessionStorage.getItem("ukey");
    if (_uky == null || _uky == undefined || _uky == "") {
      _uky = "s_" + new Date().getTime();
      window.sessionStorage.setItem("ukey", _uky);
    }
    // console.log(urlkey + "_" + _uky);
    return urlkey + "_" + _uky
  }
  catch (e) {

  }
  return ""
}
export const validURL = str => {
  let pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator
  return !!pattern.test(str);
};

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
}

// convert tokenurl to encrypted string
const hexStrToStr = hexstr => {
  let str = '';
  for (let n = 0; n < hexstr.length; n += 2) {
    str += String.fromCharCode(parseInt(hexstr.substr(n, 2), 16));
  }
  return str;
};

// encryptedUrl - tokenurl after hex conversion
// decryptKey - odd char from o-auth
const enDecrypt = (encryptedUrl, decryptKey) => {
  let sbox = [],
    key = [],
    tempSwap,
    password = decryptKey;
  for (let p = 0; p < 256; p++) {
    key[p] = password.charCodeAt(p % password.length);
    sbox[p] = p;
  }
  let b = 0;
  for (let a = 0; a < 256; a++) {
    b = (b + sbox[a] + key[a]) % 256;
    tempSwap = sbox[a];
    sbox[a] = sbox[b];
    sbox[b] = tempSwap;
  }
  let i = 0,
    j = 0,
    k;

  let cipher = '';
  for (let y = 0; y < encryptedUrl.length; y++) {
    i = (i + 1) % 256;
    j = (j + sbox[i]) % 256;
    let tempSwap = sbox[i];
    sbox[i] = sbox[j];
    sbox[j] = tempSwap;
    k = sbox[(sbox[i] + sbox[j]) % 256];
    let cipherBy = encryptedUrl.charCodeAt(y) ^ k;
    cipher += String.fromCharCode(cipherBy); //check
  }
  return cipher;
};

export const doFunct = (text, decryptKey = 'imS2lf$#12904') => {
  // const encrypted = hexStrToStr(text);
  return strToHeXstring(enDecrypt(text, decryptKey));
};

const strToHeXstring = str => {
  return str
    .split('')
    .map(c => c.charCodeAt(0).toString(16).padStart(2, '0'))
    .join('');
};

export function capatalize(input) {
  return input
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
}

export function consoleLog(string, value) {

  console.log(string, value || '');

  try {
    if (value.length < 300) {
      // global.requesttime += string + '|' + (value || '') + '\r\n';
    }
  } catch (e) { }
}

export function LogTimetaken(resp) {
  try {
    if (resp.config.headers['X-IMI-RNST'] != null) {
      let _url = resp.config.url;
      let _param = resp.config.data;
      let _rt = resp.config.headers['X-IMI-RNST'];
      let _total = new Date().getTime() - _rt;
      // global.requesttime +=
      //   _url.replace('BASE_URL', '') + '|' + _total + '\r\n';
      consoleLog('TT', _total);
    }
  } catch (e) { }
}
export function GetTimetaken(resp) {
  try {
    if (resp.config.headers['X-IMI-RNST'] != null) {
      let _rt = resp.config.headers['X-IMI-RNST'];
      let _total = new Date().getTime() - _rt;
      return _total;
    }
  } catch (e) { }
  return 0;
}
export function LogHttpError(url, data, error) {
  try {
    if (data.config.headers['X-IMI-RNST'] != null) {
      let _url = url;
      let _param = data + '\r\n' + error;
      // global.requesttime += _url + '|' + _param + '|' + '' + '\r\n';
    }
  } catch (e) { }
}

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const BiometricSensorErrorCode = [
  'E_FAILED_TO_SHOW_AUTH',
  'LAErrorSystemCancel',
  'LAErrorPasscodeNotSet',
  'LAErrorTouchIDNotAvailable',
  'LAErrorTouchIDNotEnrolled',
  'RCTTouchIDUnknownError',
  'RCTTouchIDNotSupported',
];


// Encrypted - Decrypted Data with the help of RC4

/**
 * Its use to set encrypted item in AsyncStorage
 * @param key
 * @param value
 */
export const setItem = async (key, value) => { 
  try {
    if(key != null && key != undefined && key != "" && key == "tokenid"){
       key="authkey";
      window.sessionStorage.setItem(key, value);
    }
    else{
    window.sessionStorage.setItem(key, RC4Encrypt(value));
    }
    //alert("setting lang in session:"+ window.sessionStorage.getItem("selectedLang"))
  } catch (e) { }
};

export const setItemInSessionStorage = (key, value) => {
  try {
    window.sessionStorage.setItem(key, RC4Encrypt(value));
    //alert("setting lang in session:"+ window.sessionStorage.getItem("selectedLang"))
  } catch (e) { }
};



/**
 * It's use to get decrypted item from AsyncStorage
 * @param key
 * @param defaultValue
 */
export const getItem = async (key, defaultValue) => {
  let output = defaultValue || null;
  try {
    const value = window.sessionStorage.getItem(key);
    if(key != null && key != undefined && key != "" && key == "tokenid"){
      const value = window.sessionStorage.getItem("authkey");
      if (value !== null && value != undefined && value != "") {
        output = value;
      }
    }else{
      if (value !== null && value != undefined && value != "") {
        output = RC4Decrypt(value);
      }
    }
  } catch (e) { }

  return output;
};


/**
 * It's use to get decrypted item from AsyncStorage
 * @param key
 * @param defaultValue
 */
export const getItemOfSessionStorage = (key, defaultValue) => {
  let output = defaultValue || null;
  // if(key != null && key != undefined && key != "" && key == "selectedLang")
  // {
  //   output = localStorage.getItem("lang");
  //   return output;
  // }
  try {
    const value = window.sessionStorage.getItem(key);
    if (value !== null) {
      output = RC4Decrypt(value);
    }
  } catch (e) { }

  return output;
};

export function GetMobileNo(msisdn) {
  try {
    if (msisdn.length == 11 && msisdn.indexOf('965') == 0) {
      return msisdn.substring(3);
    }
  } catch (e) {}
  return msisdn;
}

export function GetGreetText(t) {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return t('goodMorning');
  } else if (currentHour < 18) {
    return t('goodAfternoon');
  } else {
    return t('goodEvening');
  }
}
export function GetHomeGreetText(t) {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return t('good_Morning');
  } else if (currentHour < 18) {
    return t('good_Afternoon');
  } else {
    return t('good_Evening');
  }
}
export function GetMoreGreetText(t) {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return t('goodmorning');
  } else if (currentHour < 18) {
    return t('goodafternoon');
  } else {
    return t('goodevening');
  }
}

/**
 * It's use to remove item from AsyncStorage
 * @param key
 */
export const removeItem = key => {
  try {
    // consoleLog('removeItem', key);
    window.sessionStorage.removeItem(key);
  } catch (e) {
    console.error("An error occurred while removing the item from sessionStorage:", e?.message);
  }
};

// End

export const TO_LOWER_CASE = val => {
  try {
    if (!val) {
      return '';
    } else {
      return val.toLowerCase();
    }
  } catch (error) { }
  return '';
};

export const TO_UPPER_CASE = val => {
  try {
    if (val == null || val == undefined || val === '') {
      return '';
    } else {
      return val.toUpperCase();
    }
  } catch (error) { }
  return val;
};

// export const JsonCallbackWebview = data => {
//   try {
//     consoleLog('JsonCallbackWebview', data);
//     var obj = JSON.parse(data);
//     let action = obj?.key;
//     let value = JSON.parse(obj?.value);
//     if (action === 'authsuccess') {
//       let hash = value?.hash;
//       let objdata = value?.data;
//       let tokenid = global.tokenid ?? Date.now().toString();
//       const headerHash = `${JSON.stringify(objdata)}&SALT=${getOddPlaces(
//         tokenid
//       )}`;
//       const hdSignHash = sha512(headerHash);
//       if (hdSignHash === hash) {
//         consoleLog('JsonCallbackWebview', data);
//         if (objdata?.simtype === 'physicalsim') {
//           return objdata;
//         } else {
//           return objdata;
//         }
//       }
//     } else if (action === 'authfail') {
//       let hash = value?.hash;
//       let objdata = value?.data;
//       let tokenid = global.tokenid ?? Date.now().toString();
//       const headerHash = `${JSON.stringify(objdata)}&SALT=${getOddPlaces(
//         tokenid
//       )}`;
//       const hdSignHash = sha512(headerHash);
//       if (hdSignHash === hash) {
//         consoleLog('JsonCallbackWebview', data);
//         if (objdata?.simtype === 'physicalsim') {
//           return objdata;
//         } else {
//           return objdata;
//         }
//       }
//     }
//     return '';
//   } catch (e) { }
// };



export const isLinkExternal = val => {
  try {
    if (val == null || val === undefined) {
      return false;
    }
    if (
      val == 'False' ||
      val == 'false' ||
      val == 'F' ||
      val == 'f' ||
      val === false
    ) {
      return false;
    }
    if (
      val == 'True' ||
      val == 'true' ||
      val == 'T' ||
      val == 't' ||
      val == '1' ||
      val === true
    ) {
      return true;
    }
  } catch (e) { }
  return false;
};
export const GetMaxHeight = (count, def, max) => {
  try {
    let _cnt = count * def;
    if (max < _cnt) {
      return max;
    } else {
      if (def > _cnt) {
        return def;
      } else {
        return _cnt;
      }
    }
  } catch (e) { }
  return max;
};
export function UnitTestProps(pagename, type, id) {
  try {
    let _key =
      pagename.replace(' ', '').replace(' ', '').replace(' ', '') +
      '_' +
      type.replace(' ', '').replace(' ', '') +
      '_' +
      id.replace(' ', '').replace(' ', '');
    // consoleLog('Appium Key', _key);
    return { testID: _key, accessibilityLabel: _key };
  } catch (e) {
    consoleLog(e);
  }
  return {};
}

export const decodeUnicode = str => {
  try {
    var unicodeStr = str;
    var r = /\\u([\d\w]{4})/gi;
    unicodeStr = unicodeStr.replace(r, function (match, grp) {
      return String.fromCharCode(parseInt(grp, 16));
    });
    return unicodeStr;
  } catch (e) { }
};

export const isnojoomkeyword = str => {
  try {
    const nojoomkeywords = [
      'nojoom',
      'nojoomdeals',
      'buynojoompoints',
      'nojoomhistory',
      'nojoommynumbers',
      'transferyourpoints',
      'nojoomservices',
      'earnpartners',
      'nojoompointshistory',
      'earnpartnerdetails',
      'loyaltypartnerdetails',
      'nojoompartners',
    ];
    if (nojoomkeywords.indexOf(str) != -1) {
      return true;
    }
  } catch (e) { }
  return false;
};


export const loginencrypt = (text, decryptKey = 'imS2lf$#12904') => {
  return strToHeXstring(enDecrypt(text, decryptKey));
};

export const rslError = (errorObject) => {
  const error = []

  error.push(`[${errorObject.provider}][${errorObject.type}] ${errorObject.description}`)

  if (errorObject.error) {
    error.push(JSON.stringify(errorObject.error, null, 2))
  }

  return Error(error.join('\n\nORIGINAL ERROR: '))
}

export const timestampFromNow = (duration) => {
  const expiresAt = new Date()

  return expiresAt.setSeconds(expiresAt.getSeconds() + duration)
}

export const isEmptyObj = (obj) => {
  if (obj) {
    return Object.keys(obj).length === 0;
  } else {
    return false
  }
}

const exceptionalSymbolsForNumberValidation = ['e', 'E', '+', '-', '.'];
export const validateNumberField = (e) =>
  exceptionalSymbolsForNumberValidation.includes(e.key) && e.preventDefault();

/**
 * function to convert blob to base64
 * @param {*} blob: blob - file obj 
 * @returns 
 */
export const blobToBase64 = blob => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};


export const isContainAlphabet = (string = '') => {
  let regExp = /[a-zA-Z]/g;
              
  if(regExp.test(string)){
    /* do something if letters are found in your string */
    return true;
  } else {
    /* do something if letters are not found in your string */
    return false
  }
}

// export const getUniqueObjByKey = (array, key) => {
//   return [...new Map(array.map(item =>
//     [item[key], item])).values()];
// }
export const getUniqueObjByKey = (array, key) => {
  const uniqueMap = new Map();
  for (let arr of array) {
    if(!uniqueMap.has(arr[key])){
    uniqueMap.set(arr[key], arr);
    }
  }
 var iteratorValues = uniqueMap.values();
 var uniqueValues = [...iteratorValues];
 return uniqueValues;
}

export const transformNojoomPartnerRewards = (data) => {
  try {
    let _categories = [];
    for (let i = 0; i < data.length; i++) {
      let _catgitem = _categories.filter(x => x.catgname == data[i].category);
      if (
        _catgitem == null ||
        _catgitem == undefined ||
        _catgitem.length == 0
      ) {
        let itm = {
          id: data[i].id,
          catgname: data[i].category,
          name: data[i].category,
          image: data[i].image,
          categoryimage: data[i].categoryimage,
          partnertype: data[i].partnertype,
          categorydesc: data[i].categorydesc,
          data: [],
        };
        itm.data.push(JSON.parse(JSON.stringify(data[i])));
        _categories.push(itm);
      } else {
        if (_catgitem != null && _catgitem.length > 0) {
          _catgitem[0].data.push(JSON.parse(JSON.stringify(data[i])));
        }
      }
    }
    return _categories;
  } catch (e) {}
  return [];
}

export const addIdKey = (arr) => {
  return arr.map((item, index) => {
    return {
      id: (index + 1).toString(),
      ...item
    }
  })
}

export const getGlobalSettingValue = (key, settingsArr) => {
  try {
    let settValue = settingsArr?.find(
      setting => setting?.meta_key === key
    );

    if (settValue) {
      if (getItemOfSessionStorage(SELECTED_LANG) === 'en') {
        return settValue?.meta_value_english;
      } else {
        return settValue?.meta_value_arabic;
      }
    } else {
      return '';
    }
  } catch (error) {}
};

export function secondsToHms(d) {
    d = Number(d);
    // var h = Math.floor(d / 3600);
    let m = Math.floor((d % 3600) / 60);
    let s = Math.floor((d % 3600) % 60);

    // console.log('m, s', m, s);
    return `${m < 10 ? `${m}` : m}:${s < 10 ? `0${s}` : s}`; 
}

export const handleLangUrlRedirect = () => {
  const language = getItemOfSessionStorage(SELECTED_LANG);

    // if(window.location.href.indexOf('/en#') !== -1){
    //   if(language !== 'en'){
    //     setItem(SELECTED_LANG, "en");
    //     window.location.href = window.location.href.replace('/en#', '#');
    //   }else{
    //     window.location.href = window.location.href.replace('/en#', '#');
    //   }
    // }else if(window.location.href.indexOf('/ar#') !== -1){
    //   if(language !== 'ar'){
    //     setItem(SELECTED_LANG, "ar");
    //     window.location.href = window.location.href.replace('/ar#', '#');
    //   }else{
    //     window.location.href = window.location.href.replace('/ar#', '#');
    //   }
    // }else if(window.location.href.indexOf('/en') !== -1){
    //   if(language !== 'en'){
    //     setItem(SELECTED_LANG, "en");
    //     window.location.href = window.location.href.replace('/en', '');
    //   }else{
    //     window.location.href = window.location.href.replace('/en', '');
    //   }
    // }else if(window.location.href.indexOf('/ar') !== -1){
    //   if(language !== 'ar'){
    //     setItem(SELECTED_LANG, "ar");
    //     window.location.href = window.location.href.replace('/ar', '');
    //   }else{
    //     window.location.href = window.location.href.replace('/ar', '');
    //   }
    // }

    // to handle en urls
    if(window.location.href.endsWith('/en')){
      if(language !== 'en'){
        setItem(SELECTED_LANG, "en");
        window.location.href = window.location.href.replace('/en', '');
      }else{
        window.location.href = window.location.href.replace('/en', '');
      }
    }else if(window.location.href.indexOf('/en/') !== -1){
      if(language !== 'en'){
        setItem(SELECTED_LANG, "en");
        window.location.href = window.location.href.replace('/en', '');
      }else{
        window.location.href = window.location.href.replace('/en', '');
      }
    }else if(window.location.href.indexOf('/en#') !== -1){
      if(language !== 'en'){
        setItem(SELECTED_LANG, "en");
        window.location.href = window.location.href.replace('/en', '/');
      }else{
        window.location.href = window.location.href.replace('/en', '/');
      }
    // to handle ar urls
    }else if(window.location.href.endsWith('/ar')){
      if(language !== 'ar'){
        setItem(SELECTED_LANG, "ar");
        window.location.href = window.location.href.replace('/ar', '');
      }else{
        window.location.href = window.location.href.replace('/ar', '');
      }
    }else if(window.location.href.indexOf('/ar/') !== -1){
      if(language !== 'ar'){
        setItem(SELECTED_LANG, "ar");
        window.location.href = window.location.href.replace('/ar', '');
      }else{
        window.location.href = window.location.href.replace('/ar', '');
      }
    }else if(window.location.href.indexOf('/ar#') !== -1){
      if(language !== 'ar'){
        setItem(SELECTED_LANG, "ar");
        window.location.href = window.location.href.replace('/ar', '/');
      }else{
        window.location.href = window.location.href.replace('/ar', '/');
      }
    }
}

// endswith /en 
// indexof /en/
// indexof /en#

// function to validate file extention - default (['jpg','jpge', 'png'])
export const isValidFileExtention = (file, allowedExtensions = ['jpg','jpeg', 'png']) => {
  try{
    const { name } = file;
    const fileExtension = name.split(".").pop();
    return allowedExtensions.includes(fileExtension?.toLowerCase());
  }catch(error){
    return error;
  }
}

// function to validate file size - default (1 MB)
export const isValidFileSize = (file, sizeLimit = 1_000_000) => {
  try{
    const { size } = file;
    return size < sizeLimit;
  }catch(error){
    return error;
  }
}

// function to get base64 from file
export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});
const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_MAX_LENGTH = 16;

export const isValidPassword = (password) => {
  if(password.length < PASSWORD_MIN_LENGTH || password.length > PASSWORD_MAX_LENGTH){
    return false;
  }else{
    return true;
  }
}

export const validateOldPassword = (password) => {
  if(constantTimeCompare(password, '')){
      return 'old_password_is_required'
  }else if(password?.length < 8 || password?.length > 16){
      return 'please_enter_valid_password'
  }else{
      return ''
  }
}

export const validateNewPassword = (password) => {
  if(constantTimeCompare(password, '')){
      return 'new_password_required'
  }else if(password?.length < 8 || password?.length > 16){
      return 'please_enter_valid_password'
  }else{
      return ''
  }
}

// export const validateConfirmPassword = (password, conformPassword) => {
//   if(conformPassword === ''){
//       return 'confirm_password_required'
//   }else if(password !== conformPassword){
//       return 'password_confirm_password_match'
//   }else{
//       return ''
//   }
// }

function constantTimeCompare(val1, val2) {
  // Ensure both values are strings
  if (typeof val1 !== 'string' || typeof val2 !== 'string') {
      return false;
  }

  // Perform constant-time comparison
  let mismatch = 0;
  for (let i = 0; i < val1.length; i++) {
      mismatch |= val1.charCodeAt(i) ^ val2.charCodeAt(i);
  }
  return mismatch === 0 && val1.length === val2.length;
}

export const validateConfirmPassword = (password, confirmPassword) => {
  if (constantTimeCompare(confirmPassword, '')) {
      return 'confirm_password_required';
  } else if (!constantTimeCompare(password, confirmPassword)) {
      return 'password_confirm_password_match';
  } else {
      return '';
  }
}

export const validateCivilId = (civilId) => {
  if(civilId === ''){
      return 'civilId_required'
  }else if(civilId.length !== 4){
      return 'please_enter_last_4_digits'
  }else{
      return ''
  }
}

export const validateCode = (code) => {
  if(code === ''){
      return 'code_required'
  }else if(code.length !== 5){
      return 'please_enter_5_digit_code'
  }else{
      return ''
  }
}

export const isAllEmptyValue = (obj) => {
  return Object.values(obj).every(x => !x);
}

export const validateName = (name) => {
  if(name === ''){
      // return ''
      return 'name_required'
  }else{
      return ''
  }
}

export const validateNickname = (nickname) => {
  if(nickname === ''){
      return ''
      // return 'Nickname required'
  }else{
      return ''
  }
}

export const validateDob = (dob) => {
  if(!dob){
      return ''
      // return 'Dob required'
  }else{
      return ''
  }
}

export const validateGender = (gender) => {
  if(gender === ''){
      return ''
      // return 'Gender required'
  }else{
      return ''
  }
}

export const validateEmailField = (email) => {
  if(email === ''){
      return ''
  }else if(!validateEmail(email)){
      return 'please_enter_valid_email'
  }else{
    return ''
  }
}

export const isContainEmoji = (str) => {
  if(str.length > 0){
    let strSplit = str.toString().split(''); // split the value
  
    let containEmoji = '';                   
    for (let i = 0; i < strSplit.length; i++) {
        if (strSplit[i].charCodeAt().toString().split('').length > 4) {//check emoji
            containEmoji = 'emojiis';
            return true;
        }
    }
  }else{
    return false;
  }
} 

export function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}